import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Hebergement : any = {};
Hebergement.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/add`, data)
}

Hebergement.verifyForm = async(data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/verify`,data);
}

Hebergement.getHomeData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/home/${code}`)
}

Hebergement.getAllData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/all/${code}`)
}

Hebergement.submitReservation = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/send/reservation`, data)
}
Hebergement.submitFormUp = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/send/update/popup/hebergement`, data)
}

Hebergement.saveComment = async(data:any)=>{
   return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/hebergment/save/comment`,data)
}

Hebergement.getAllComment = async(id:any)=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/get/all/${id}`);
}

export default Hebergement;